export class Historyitem {

  constructor(public header: string, public image: string, public text?: string, public popover?: string) { }

  public subitems: Historyitem[] = [];
}
